import { useEffect, useState } from "react"
import { useUpdateEffect } from "react-use"
import * as ICombobox from "../Combobox"

interface Props {
  onInputValueChange: (value: string) => void
  items: ReadonlyArray<string>
  onValueSelect: (value: string) => void
  placeholder?: string
}

const Combobox = ({ onInputValueChange, onValueSelect, placeholder, items, ...comboboxProps }: Props) => {
  const [search, setSearch] = useState<string | null>(null)
  const [selectedValue, setSelectedValue] = useState<string | null>(null)
  const [managedItems, setManagedItems] = useState<ReadonlyArray<string>>(items)

  useEffect(() => {
    setManagedItems(items)
  }, [items])

  useUpdateEffect(() => {
    if (search) {
      onInputValueChange?.(search)
    }
  }, [search])

  useEffect(() => {
    if (selectedValue) {
      onValueSelect?.(selectedValue)
    }
  }, [selectedValue, onValueSelect])

  return (
    <ICombobox.Root items={managedItems} {...comboboxProps}>
      <ICombobox.Input
        placeholder={placeholder}
        onInputValueChange={(value: string | null) => {
          setSearch(value)
        }}
      />
      <ICombobox.Content
        onValueSelect={(value: string | null) => {
          setSelectedValue(value)
          setSearch(null)
        }}
      />
    </ICombobox.Root>
  )
}

Combobox.defaultProps = {
  placeholder: undefined,
}

Combobox.displayName = `InputGroup.Combobox`

export { Combobox }
